<template>
  <div style="height: 500px">
    <video
        height="500"
             :responsive="true"
             :duration="true"
              preload="auto" controls ref="videoPlayer" class="video-js vjs-fluid  vjs-volume-level  vjs-paused vjs-user-inactive vjs-remaining-time-display">
      <source :src="$replaceHttps(videoSrc)" type="video/mp4" />
    </video>
  </div>
</template>

<script>
import videojs from 'video.js';

export default {
  name: "VideoPlayer",
  props: ['videoSrc'],
  data() {
    return {
      player: null
    }
  },
  mounted() {

    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      // this.player.log('onPlayerReady', this);
      // window.addEventListener ("touchmove", function (event) { event.preventDefault (); }, {passive: false});

      // this.player.on('touchstart', (e) => { e.preventDefault() },{passive: false});

    });

  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style scoped>

</style>
